import get from 'lodash/get';
import { createReducer } from '@reduxjs/toolkit';
import * as actions from 'store/findProvider/actions';
import { Nullable } from 'modules/types/common';
import * as types from '../types';
import { START_PAGE_NUMBER } from '../constants';

const CommentsInitState = {
  isFetching: false,
  comments: [] as types.Comment[],
  commentPageNumber: START_PAGE_NUMBER,
  error: null as Nullable<Error>
};

export type CommentsState = typeof CommentsInitState;

export const providerCommentsReducer = createReducer(CommentsInitState, {
  [actions.PROVIDER_RESET_COMMENTS]: () => {
    return CommentsInitState;
  },
  [actions.PROVIDER_GET_COMMENTS]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.PROVIDER_GET_COMMENTS_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.commentPageNumber += 1;
    state.comments = state.comments.concat(get(action, 'payload.data.comments'));
  },
  [actions.PROVIDER_GET_COMMENTS_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
  }
});

export default providerCommentsReducer;
